/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TenantDto } from './TenantDto';
import {
    TenantDtoFromJSON,
    TenantDtoFromJSONTyped,
    TenantDtoToJSON,
    TenantDtoToJSONTyped,
} from './TenantDto';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * 
 * @export
 * @interface TenantResponse
 */
export interface TenantResponse {
    /**
     * 
     * @type {TenantDto}
     * @memberof TenantResponse
     */
    data?: TenantDto;
    /**
     * 
     * @type {string}
     * @memberof TenantResponse
     */
    userTimezone?: string;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof TenantResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof TenantResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof TenantResponse
     */
    timezoneMetadata?: TimezoneMetadata;
}

/**
 * Check if a given object implements the TenantResponse interface.
 */
export function instanceOfTenantResponse(value: object): value is TenantResponse {
    return true;
}

export function TenantResponseFromJSON(json: any): TenantResponse {
    return TenantResponseFromJSONTyped(json, false);
}

export function TenantResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : TenantDtoFromJSON(json['data']),
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
    };
}

export function TenantResponseToJSON(json: any): TenantResponse {
    return TenantResponseToJSONTyped(json, false);
}

export function TenantResponseToJSONTyped(value?: TenantResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': TenantDtoToJSON(value['data']),
        'userTimezone': value['userTimezone'],
        'success': value['success'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
    };
}

